import {Directive, Input, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import { EnvService } from '../env.service';

@Directive({
    selector: '[featureFlag]'
})
export class FeatureFlagDirective implements OnInit {
    @Input() featureFlag: string;

    constructor(
        private vcr: ViewContainerRef,
        private tpl: TemplateRef<any>,
        private envService: EnvService
    ) {
    }

    ngOnInit() {
        if (this.envService.isFeatureEnabled(this.featureFlag)) {
            this.vcr.createEmbeddedView(this.tpl);
        }
    }

}
